import { render, staticRenderFns } from "./coupon_task_add.vue?vue&type=template&id=df6698f6"
import script from "./coupon_task_add.vue?vue&type=script&lang=js"
export * from "./coupon_task_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports